@if (CompanyVendor && ExemptVendor && Company) {
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <label class="title-label"
          >VIVE Vetting - {{ ExemptVendor.legalName }}
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col">
            <app-display-card>
              <div class="inner-panel rounded">
                <div class="row">
                  <div class="col-flex-26">
                    <label>Vendor Name & ID:</label>
                  </div>
                  <div class="col">
                    <label class="fw-normal"
                      >{{ ExemptVendor.legalName }} ({{
                        ExemptVendor.id
                      }})</label
                    >
                  </div>
                </div>
                @if (ExemptVendor.dba) {
                  <div class="row">
                    <div class="col-flex-26">
                      <label>Vendor DBA:</label>
                    </div>
                    <div class="col">
                      <label class="fw-normal">{{ ExemptVendor.dba }}</label>
                    </div>
                  </div>
                }
                <div class="row">
                  <div class="col-flex-26">
                    <label>Client Name & ID:</label>
                  </div>
                  <div class="col">
                    <label class="fw-normal"
                      >{{ Company.legalName }} ({{ Company.id }})</label
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-flex-26">
                    <label>Vendor Status w/ Client:</label>
                  </div>
                  <div class="col">
                    <span appStatusStyleChanges>
                      {{ CompanyVendor.viveStatus }}
                      @if (CompanyVendor.isArchived) {
                        (Archived)
                      }
                    </span>
                    @if (CompanyVendor.viveSubStatus) {
                      <span> - {{ CompanyVendor.viveSubStatus }}</span>
                    }
                  </div>
                </div>
              </div>
            </app-display-card>
          </div>
        </div>
        <div class="row my-3">
          <div class="col">
            <app-display-card>
              <div class="inner-panel rounded">
                <router-outlet></router-outlet>
              </div>
            </app-display-card>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="row row-padding">
          <div class="col">
            <button
              class="btn btn-primary h-100"
              (click)="addEditExemptVendor()"
            >
              OVERVIEW
            </button>
          </div>
        </div>
        <div class="row row-padding">
          <div class="col">
            <button
              class="btn btn-primary h-100"
              (click)="viewDocumentsAndNotes()"
            >
              Documents / notes
            </button>
          </div>
        </div>

        @if (CompanyVendor && !CompanyVendor.isArchived) {
          <div class="row row-padding">
            <div class="col">
              <button
                class="btn btn-primary h-100"
                (click)="updateEINAutoLink()"
              >
                {{ CompanyVendor.allowEinAutoLink ? 'Disable' : 'Enable' }} EIN
                auto-link
              </button>
            </div>
          </div>
          <div class="row row-padding">
            <div class="col">
              <button
                class="btn btn-primary h-100"
                (click)="convertExemptVendorToClientRegistered()"
              >
                Convert Vendor to
                {{
                  Company.allowAutomatedBusinessVerificationClientRegisteredVendors
                    ? 'Business Verified'
                    : 'Non-Verified'
                }}
              </button>
            </div>
          </div>
          <div class="row row-padding">
            <div class="col">
              <button
                class="btn btn-primary h-100"
                (click)="archiveClientVendor()"
              >
                Archive client vendor
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
